export default __webpack_public_path__ + "static/media/fruit-trees.bb675e4c.png";